import { GET_LANGUAGE_SUCCESS, CHANGE_THEME_MODE, TOGGLE_THEME_MODE } from "./constants";

export const changeLanguage = (language) => async (dispatch) => {
  dispatch({ type: GET_LANGUAGE_SUCCESS, payload: language });
};

export const changeTheme = (themeMode) => async (dispatch) => {
  dispatch({ type: CHANGE_THEME_MODE, payload: themeMode });
};

export const toggleThemeMode = () => async (dispatch) => {
  dispatch({ type: TOGGLE_THEME_MODE });
};
